const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.05,
    height: 24.05,
    viewBox: "0 0 24.05 24.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "gas-station (1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4857",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z",
    transform: "translate(.05 .05)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5804"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21941",
    d: "M.767 21.47h.767V1.534H.767A.767.767 0 0 1 .767 0h18.4a.767.767 0 0 1 .542.225l1.534 1.534a.767.767 0 1 1-1.084 1.084l-1.307-1.309H7.254L3.067 6.418V21.47H4.6V9.2a.767.767 0 0 1 .767-.767h7.668a.767.767 0 0 1 .765.767v9.2h1.534V9.968A.767.767 0 0 1 16.1 9.2h2.119a2.288 2.288 0 0 1 2.057 1.271l.344.69a.767.767 0 0 1-1.373.685l-.343-.685a.762.762 0 0 0-.686-.428h-1.349v8.437a.767.767 0 0 1-.767.767H13.8v1.533h8.435a.767.767 0 1 1 0 1.534H.767a.767.767 0 0 1 0-1.534zM5.234 1.534H3.067v2.53zm7.035 8.435H6.134V20.7h6.134zm0 0",
    transform: "translate(.05 .05)",
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: ".1px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21942",
    d: "M243.834 228.6h-3.067a.767.767 0 0 1-.767-.767v-3.067a.767.767 0 0 1 .767-.767h3.067a.767.767 0 0 1 .767.767v3.067a.767.767 0 0 1-.767.767zm-.767-3.067h-1.534v1.534h1.534zm0 0",
    transform: "translate(-233.049 -213.215)",
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: ".1px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21943",
    d: "M16 292.239c0-.98 1.167-2.776 1.669-3.5a.8.8 0 0 1 1.262 0c.5.727 1.669 2.523 1.669 3.5a2.3 2.3 0 0 1-4.6 0zm3.067 0a5.718 5.718 0 0 0-.767-1.646 5.72 5.72 0 0 0-.767 1.646.767.767 0 0 0 1.534 0zm0 0",
    transform: "translate(1.686 -274.554)",
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: ".1px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.6d7a074efeeea77f30c31d2ff608ecd8.svg";
export { ForwardRef as ReactComponent };